import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'docs',
  title: '文档与组件',
  routes: [
    { path: '/components', name: 'components', component: () => import('@/features/design/ComponentsView.vue'), meta: { tab: 'apps' } },
    { path: '/docs', name: 'doc', component: () => import('./DesignDoc.vue'), meta: {} },
    { path: '/help', name: 'help', component: () => import('./HelpView.vue'), meta: {} },
  ],
} satisfies FeatureModule
